import { Routes, Route, BrowserRouter } from "react-router-dom"
import NotFound from "./Components/NotFound/NotFound"
import { ProtectedRoute } from "./Components/ProtectedRoute/ProtectedRoute"
import Login from "./Components/Login/Login";
import { Role } from "./models/Role";
import DashboardTab from "./Components/Tab/DashboardTab";

const Unauthorized = () => {
    return <h1>Unauthorized</h1>
}

const App = () => {
    return (
        <BrowserRouter>
            <Routes>
                {/* public routes */}
                <Route path="login" element={<Login/>}></Route>
                <Route path="unauthorized" element={ <Unauthorized/>}></Route>


                {/* private routes */}
                <Route element={<ProtectedRoute allowedRoles={[Role.Manager]}/>}>
                    <Route path="/*" element={<DashboardTab/>}> </Route>
                </Route>

                {/* catch all routes */}
                <Route path="*" element={<NotFound/>} ></Route>

            </Routes>
        </BrowserRouter>
    )
}

export default App;